import React, { forwardRef } from 'react';
interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
}
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  label,
  error,
  className = '',
  id,
  ...props
}, ref) => {
  const checkboxId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="flex items-start" data-id="element-170">
        <div className="flex items-center h-5" data-id="element-171">
          <input ref={ref} type="checkbox" id={checkboxId} className={`
              w-4 h-4 rounded border-gray-300 text-blue-600
              focus:ring-2 focus:ring-blue-500 focus:ring-offset-0
              disabled:opacity-50 disabled:cursor-not-allowed
              ${error ? 'border-red-500' : ''}
              ${className}
            `} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${checkboxId}-error` : undefined} {...props} data-id="element-172" />
        </div>
        {label && <label htmlFor={checkboxId} className="ml-2 text-sm text-gray-700 cursor-pointer select-none" data-id="element-173">
            {label}
          </label>}
        {error && <p id={`${checkboxId}-error`} className="ml-2 text-sm text-red-600" data-id="element-174">
            {error}
          </p>}
      </div>;
});
Checkbox.displayName = 'Checkbox';